import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Style imports — order matters: fonts → tokens → reset → global
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/reset.css";
import "./styles/global.css";

import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
